

export function appendDescriptionAttribute(toAppend: any, description?: string, deduplicate?: boolean, separator?: string): string {
  deduplicate = deduplicate == null ? true : deduplicate;
  separator = separator == null ? ' - ' : separator;
  if (description == null) {
    description = '';
  }
  description = description.trim();

  var toAppendText = '';
  if (toAppend != null) {
    toAppendText = '' + toAppend;
  }
  toAppendText = toAppendText.trim();

  if (deduplicate && description.toLowerCase().indexOf(toAppendText.toLowerCase()) >= 0) {
    return description;
  }

  if (toAppendText.length > 0) {
    if (description.length > 0) {
      description = description + separator;
    }
    description = description + toAppendText;
  }

  return description;
}